import React from 'react'
import { useForm } from "react-hook-form"
import { yupResolver } from "@hookform/resolvers/yup"

import schema from './validation'

import './Form.css'

export default function Form() {

    const { register, handleSubmit, errors } = useForm({
        resolver: yupResolver(schema),
    })

    const onSubmit = (data) => {
        console.log(data)
    }


    return (
        <div className="form-container">

            <form onSubmit={handleSubmit(onSubmit)}>
                <input
                    type="text"
                    name="email"
                    ref={register({ required: true })}
                    placeholder="Your email address"
                />
                <button> Notify Me </button>
            </form>
            <div className="erro-message" style={{ color: '#f00' }}>
                {errors.email?.message}
            </div>
        </div>
    )
}